import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/icon_refresh.svg'
import _imports_1 from '@/assets/images/home/info1.png'


const _withScopeId = n => (_pushScopeId("data-v-f6759c12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-title" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "orange" }, null, -1))
const _hoisted_4 = { style: {"font-size":"12px","color":"#999","padding-right":"10px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "刷新", -1))
const _hoisted_7 = { class: "dialogvisible-content" }
const _hoisted_8 = { class: "card-wrapper" }
const _hoisted_9 = { class: "card-item" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = { class: "card-num" }
const _hoisted_12 = { class: "card-item" }
const _hoisted_13 = { class: "card-num" }
const _hoisted_14 = { class: "card-item" }
const _hoisted_15 = { class: "card-num" }
const _hoisted_16 = { class: "card-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title" }, "冻结资金", -1))
const _hoisted_18 = { class: "card-num" }
const _hoisted_19 = { class: "card-item" }
const _hoisted_20 = { class: "card-title" }
const _hoisted_21 = { class: "card-num" }
const _hoisted_22 = { class: "card-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title" }, "持仓收益", -1))
const _hoisted_24 = { class: "card-num" }
const _hoisted_25 = { class: "card-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "card-title" }, "持仓收益率", -1))
const _hoisted_27 = { class: "card-num" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-title" }, "持仓", -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "footer" }

import {
  computed,
  defineComponent,
  reactive,
  ref,
  toRefs
} from 'vue'
import { tHeaderListDetail, tHeaderFundsListDetail } from '../data'
import { numFormat } from '@/utils/num_format'
import { ElMessageBox } from 'element-plus'
import _ from 'lodash'
import { useQuery } from '@vue/apollo-composable'
import * as gql from '@/graphql'
import { Decimal } from 'decimal.js'
import { STOCKQUOTE } from '@/define'
import {
  transformQuoteField,
  transformSocketFieldUsAfterOrBefore
} from '@/utils/formatStock'
import { useRouter } from 'vue-router'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'checkDetail',
  props: {
  dialogVisible: { type: Boolean, default: false },
  dataForm: { type: Object, default: () => ({}) }
},
  emits: ['update:dialogVisible'],
  setup(__props, { emit }) {

const props = __props;





const router = useRouter()
const state = reactive({
  HKList: [],
  USList: [],
  AList: [],
  HKobj: [],
  USobj: [],
  Aobj: [],
  obj: [] as any,
  tableData: [],
  loading: true,
  tabsByAccount: [
    {
      label: '证券账户',
      name: 'stock',
      tabs: [
        {
          label: '港股',
          name: 'HK'
        },
        {
          label: '美股',
          name: 'US'
        },
        {
          label: 'A股',
          name: 'A'
        }
      ],
      tHeader: tHeaderListDetail
    },
    {
      label: '基金账户',
      name: 'fund',
      tabs: [
        {
          label: '港元账户',
          name: 'HKD'
        },
        {
          label: '美元账户',
          name: 'USD'
        }
      ],
      tHeader: tHeaderFundsListDetail
    }
  ],
  currentTab: 'stock',
  activeName: 'HK',
  currentAccountData: {},
  lpoaFundInfoList: {}
})
const activeName = ref('HK')

// 当前sub tab
const currentSubTab = () =>
  state.tabsByAccount.find((item) => item.name === state.currentTab)?.tabs

// 当前表头
const tHeader = computed(
  () =>
    state.tabsByAccount.find((item) => item.name === state.currentTab)?.tHeader
)

const dialogVisibleFlag = computed({
  get() {
    return props.dialogVisible
  },
  set(val) {
    emit('update:dialogVisible', val)
  }
})
const { refetch: refetchA, onResult } = useQuery(gql.positionList)
onResult((res) => {
  state.loading = false
  const { lpoaPositionList, lpoaFundInfoList } = res?.data

  state.currentAccountData =
    lpoaPositionList?.data?.find(
      (item: any) => item.clientid === props.dataForm.clientId
    ) || {}

  const lpoaFundInfoListData =
    lpoaFundInfoList?.data?.find(
      (item: any) => item.clientid === props.dataForm.clientId
    ) || {}

    if (activeName.value === 'US') {
      state.obj = lpoaFundInfoListData?.info?.filter((item: any) => item.exchangeType === 'US') || []
    } else if (activeName.value === 'HK') {
      state.obj = lpoaFundInfoListData?.info?.filter((item: any) => item.exchangeType === 'HK') || []
    } else if (activeName.value === 'A') {
      state.obj = lpoaFundInfoListData?.info?.filter((item: any) => item.exchangeType === 'A') || []
    } else if (activeName.value === 'HKD') {
      state.obj = [
        {
          marketValueFund: state.currentAccountData?.marketValueFundHk || '0.00',
          positionIncomeFund:
            state.currentAccountData?.positionIncomeFundHk || '0.00',
          incomePercentFund:
            state.currentAccountData?.incomePercentFundHk || '0.00'
        }
      ]
    } else if (activeName.value === 'USD') {
      state.obj = [
        {
          marketValueFund: state.currentAccountData?.marketValueFundUs || '0.00',
          positionIncomeFund:
            state.currentAccountData?.positionIncomeFundUs || '0.00',
          incomePercentFund:
            state.currentAccountData?.incomePercentFundUs || '0.00'
        }
      ]
    }

  const infoKeyMap = {
    stock: 'info',
    fund: 'structuredFundPositionInfo'
  }

  const list =
    state.currentAccountData[infoKeyMap[state.currentTab]]?.rows || []

  if (state.currentTab === 'stock') {
    const aList =
      list?.filter((item: any) => {
        if (activeName.value === 'A') {
          return ['SH', 'SZ', 'A'].includes(item.exchangeType)
        }
        return item.exchangeType === activeName.value
      }) || []

    state.tableData = aList?.map((item: any) => {
      item.marketValueF = item.marketValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
      item.currentAmountN = item.currentAmount.toLocaleString()
      item.enableAmount = item.enableAmount.toLocaleString()
      item.profit =
        item.costPrice === 0
          ? '--'
          : item.currentPriceDisplay !== '- -'
          ? (Number(
              item.currentPriceDisplay ? item.currentPriceDisplay : '0.00'
            ) -
              item.costPrice) *
            item.currentAmount
          : '- -'
      item.profitPercent =
        item.costPrice === 0
          ? '--'
          : isNaN(
              parseFloat(
                new Decimal(item.profit)
                  .div(new Decimal(item.costPrice).mul(item.currentAmount))
                  .mul(100)
                  .toFixed(2, Decimal.ROUND_DOWN)
              )
            )
          ? '--'
          : parseFloat(
              new Decimal(item.profit)
                .div(new Decimal(item.costPrice).mul(item.currentAmount))
                .mul(100)
                .toFixed(2, Decimal.ROUND_DOWN)
            ) + '%'
      return item
    })
  } else {
    state.tableData =
      list?.filter((item: any) => item.moneyType === activeName.value) || []
  }

  // const Map = {
  //   HK: 'marketValueHk',
  //   US: 'marketValueUs',
  //   A: 'marketValueA',
  //   HKD: 'marketValueFundHk',
  //   USD: 'marketValueFundUs'
  // }

  // const key = Map[activeName.value]

  // state.totalMarketValue = state.currentAccountData[key] || '0.00'

  state.loading = false
})
// 打开对话框
const openDia = () => {
  state.loading = true
  state.currentTab = 'stock'
  activeName.value = 'HK'
  // const objArr = _.cloneDeep(props.dataForm.fundinfo)
  // state.HKobj = objArr.filter((v: any) => v.exchangeType === 'HK')
  // state.USobj = objArr.filter((v: any) => v.exchangeType === 'US')
  // state.Aobj = objArr.filter((v: any) => v.exchangeType === 'A')
  // state.obj = state.HKobj
  const arr = _.cloneDeep(props.dataForm.position)
  arr.forEach((v: any) => {
    v.costPriceN = numFormat(v.costPrice, 3) // 成本千分位
    v.currentPriceDisplayN = numFormat(v.currentPriceDisplay, 3) // 现价千分位
    v.marketValue = v.marketValue ? numFormat(v.marketValue, 2) : '- -'
    v.profitPercent =
      v.currentPriceDisplay !== ''
        ? numFormat(
            ((parseFloat(
              v.currentPriceDisplay ? v.currentPriceDisplay : '0.0'
            ) -
              v.costPrice) /
              v.costPrice) *
              100,
            2
          ) + '%'
        : '- -'
    v.profit =
      v.currentPriceDisplay !== ''
        ? (parseFloat(v.currentPriceDisplay ? v.currentPriceDisplay : '0.0') -
            v.costPrice) *
          v.currentAmount
        : '- -'
  })
  // state.HKList = _.cloneDeep(arr.filter((v: any) => v.moneyType === 'HKD'))
  // state.USList = _.cloneDeep(arr.filter((v: any) => v.moneyType === 'USD'))
  // state.AList = _.cloneDeep(arr.filter((v: any) => v.moneyType === 'CNY'))
  refetchA()
}

const handleTabAccountClick = async (val: any) => {
  activeName.value = val.props.name === 'stock' ? 'HK' : 'HKD'
  state.loading = true
  state.tableData = []
  state.obj = []
  await refetchA()
}

// 切换 tab
const handleClick = async (val: any) => {
  activeName.value = val.props.name
  state.obj = []
  state.loading = true
  await refetchA()
  // if (val.props.name === 'US') {
  //   state.obj = state.USobj
  // } else if (val.props.name === 'HK') {
  //   state.obj = state.HKobj
  // } else if (val.props.name === 'A') {
  //   state.obj = state.Aobj
  // } else if (val.props.name === 'HKD') {
  //   state.obj = [
  //     {
  //       positionIncomeFund:
  //         state.currentAccountData?.positionIncomeFundHk || '0.00',
  //       incomePercentFund:
  //         state.currentAccountData?.incomePercentFundHk || '0.00'
  //     }
  //   ]
  // } else if (val.props.name === 'USD') {
  //   state.obj = [
  //     {
  //       positionIncomeFund:
  //         state.currentAccountData?.positionIncomeFundUs || '0.00',
  //       incomePercentFund:
  //         state.currentAccountData?.incomePercentFundUs || '0.00'
  //     }
  //   ]
  // }
  // console.log(state.obj)
}

const handleTabChange = (val: any) => {
  handleClick({
    props: {
      name: val
    }
  })
}

const handleClose = () => {
  emit('update:dialogVisible', false)
}
const close = () => {
  emit('update:dialogVisible', false)
}
const confirm = () => {
  activeName.value = 'HK'
  emit('update:dialogVisible', false)
}
// 显示
const activeNameCom = (value: any) => {
  if (value === 'US') {
    return '美股总市值'
  } else if (value === 'HK') {
    return '港股总市值'
  } else if (value === 'A') {
    return 'A股总市值'
  } else if (value === 'HKD') {
    return '资产净值(港元)'
  } else if (value === 'USD') {
    return '资产净值(美元)'
  }
}
// 现金可提免责声明
const infoFetchBalance = () => {
  ElMessageBox.alert(
    '「现金可提」仅供参考，该数据或未能反映账户的实时现金可提的金额，以及或未包含其他影响现金可提的收入和费用，如交易费用和处理费用等。阁下任何依赖或就该数据所作的任何决定，金马证券概不负责。实际「现金可提」概以结单為準或联系客户服务部（cs@igoldhorse.com）垂询。',
    '免责声明',
    {
      confirmButtonText: '我知道了',
      customClass: 'message-info',
      showClose: false,
      center: true,
      type: '',
      callback: () => {
        console.log('我知道了')
      }
    }
  )
}
// 最大购买力免责声明
const infoEnableBalance = () => {
  ElMessageBox.alert(
    '「最大购买力」仅供参考，该数据或未能反映帐户的实时最大购买力，以及或未包含其他影响最大购买力的收入和费用等。阁下任何依赖或就该数据所作的任何决定，金马证券概不负责。请联系客户服务部（cs@igoldhorse.com）垂询实际「最大购买力」。',
    '免责声明',
    {
      confirmButtonText: '我知道了',
      customClass: 'message-info',
      showClose: false,
      center: true,
      type: ''
    }
  )
}

const change = (data: { btnType: String, data: any }) => {
  const arr = []
  const {
    exchangeType,
    fundAccount,
    stockCode,
    stockNameGb,
    currentPriceDisplay: entrustPrice
  } = data.data
  arr[0] = {
    exchangeType,
    fundAccount,
    stockCode,
    stockNameGb,
    entrustPrice
  }
  switch (data.btnType) {
    case 'buy':
      router.push({
        name: 'BulkTrading',
        params: {
          bidAskList: JSON.stringify(arr)
        }
      })
      break
    case 'sell':
      router.push({
        name: 'BulkTrading',
        params: {
          bidAskList: JSON.stringify(arr)
        }
      })
      break
    default:
      break
  }
}

const refresh = () => {
  state.loading = true
  refetchA()
}

const refreshTime = () => {
  return dayjs().format('YYYY-MM-DD HH:mm:ss')
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_FargoTable = _resolveComponent("FargoTable")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(dialogVisibleFlag),
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(dialogVisibleFlag) ? (dialogVisibleFlag).value = $event : null)),
    title: "",
    width: "960px",
    "before-close": handleClose,
    "close-on-click-modal": false,
    "close-on-press-escape": false,
    "destroy-on-close": "",
    "show-close": false,
    onOpen: openDia
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_30, [
        _createVNode(_component_el_button, {
          class: "content-confirm",
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(),
          _createElementVNode("span", null, _toDisplayString(__props.dataForm.nameCn) + "的账户", 1)
        ]),
        _createElementVNode("div", {
          class: "refresh",
          onClick: refresh
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(refreshTime()), 1),
          _hoisted_5,
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_tabs, {
          class: "custom-tab",
          modelValue: state.currentTab,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.currentTab) = $event)),
          onTabClick: handleTabAccountClick
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.tabsByAccount, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                label: item.label,
                name: item.name,
                key: item.name
              }, null, 8, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeName).value = $event)),
            onTabClick: handleClick,
            onTabChange: handleTabChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSubTab(), (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  label: item.label,
                  name: item.name,
                  key: item.name
                }, null, 8, ["label", "name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (state.currentTab === 'stock')
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 0,
                gutter: 20,
                class: "show-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(activeNameCom(activeName.value)), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(numFormat)(state.obj[0]?.marketValue, 2)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", { class: "card-title" }, [
                          _createTextVNode("现金可提"),
                          _createElementVNode("img", {
                            class: "img",
                            onClick: infoFetchBalance,
                            src: _imports_1,
                            alt: ""
                          }),
                          _createElementVNode("div", { onClick: infoFetchBalance })
                        ]),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(numFormat)(state.obj[0]?.fetchBalance, 2)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", { class: "card-title" }, [
                          _createTextVNode("最大购买力"),
                          _createElementVNode("img", {
                            class: "img",
                            onClick: infoEnableBalance,
                            src: _imports_1,
                            alt: ""
                          }),
                          _createElementVNode("div", {
                            class: "title-img",
                            onClick: infoEnableBalance
                          })
                        ]),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(numFormat)(state.obj[0]?.enableBalance, 2)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(numFormat)(state.obj[0]?.frozenBalance, 2)), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (state.currentTab === 'fund')
            ? (_openBlock(), _createBlock(_component_el_row, {
                key: 1,
                gutter: 20,
                class: "show-card"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(activeNameCom(activeName.value)), 1),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(numFormat)(state.obj[0]?.marketValueFund || '0.00', 2)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(numFormat)(state.obj[0]?.positionIncomeFund || "0.00", 2)), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("span", _hoisted_27, _toDisplayString(state.obj[0]?.incomePercentFund || "0.00"), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _hoisted_28,
            _createVNode(_component_FargoTable, {
              tableLoading: state.loading,
              list: state.tableData,
              "onUpdate:list": _cache[2] || (_cache[2] = ($event: any) => ((state.tableData) = $event)),
              "t-header-list": _unref(tHeader),
              height: 255,
              onChange: change
            }, null, 8, ["tableLoading", "list", "t-header-list"])
          ])
        ])
      ]),
      (state.currentTab === 'fund')
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, " 注：如阁下需赎回或追加申购基金，请致电+852 2153 3838，与客户服务部联络。 "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})